/**
*
*   Cart Provider
*       - Override the Next-intl Navigation
*
**/
'use client';

import Config from '@/config';
import CustomerCart from '@/libraries/carts/customer';
import GuestCart from '@/libraries/carts/guest';
import { createContext, useState, useEffect, useRef } from 'react';

//The Cart Context
export const CartContext = createContext(null);

//Create the Cart Context
export default function Cart({ session , children }){

	//Load the Discounts
	const [discounts, setDiscounts] = useState( (()=>{
		try {

			//Parse the JSON and return
			return JSON.parse(
				typeof window != 'undefined' ? ( localStorage.getItem('cart.discounts') || '[]' ) : '[]'
			);

		}catch(e) {

			//Failed, just return an emtpy array
			return [];

		}
	})() );

	//Prepare the Discounts Object
	const Discounts = {

		//Get all the Discounts
		get: () => discounts,

		//Add the Discount Codes
		add: async code => {

			//Create new array
			const codes = new Set( [ ...discounts , code ] );

			//Apply to env
			setDiscounts([ ...codes ]);

			//Store Array
			localStorage.setItem( 'cart.discounts' , JSON.stringify([ ...codes ]) );

		},

		//Remove Line Item from the Cart
		remove: async (code) => {

			const index = discounts.indexOf( code );

			//Not Found
			if(!index) return;

			//Remove from array
			const updated = discounts.splice( index , 1 );

			//Update to env
			setDiscounts(updated);

			//Store Array
			localStorage.setItem( 'cart.discounts' , JSON.stringify(updated) );

		},

		//Empty the Dicounts
		clear: () => localStorage.removeItem('cart.discounts') && setDiscounts( [] )

	};

	//Get the Cart Type
	const Cart = (
		session ?
			CustomerCart( Discounts )
		:
			GuestCart( Discounts)
	)

	//Return the Provider
	return (
		<CartContext.Provider value={{ Cart , Discounts }}>
			{children}
		</CartContext.Provider>
	)

}